module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de contratos")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarListaSolicitudesAprobadas) ? _c('div', {
    key: "lista_solicitudes_aprobadas",
    staticClass: "box position-relative"
  }, [_c('lista-solicitudes-aprobadas', {
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudesAprobadas = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66d2e90c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Contratos_Gestion.vue
// module id = 892
// module chunks = 0